import * as React from "react";
import { Nav } from "reactstrap";
import HamburgerIcon from "./HamburgerIcon";
import { FaSignOutAlt } from "react-icons/fa";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
// Context API
import { AppContextConsumer } from "../ContextProvider";

// Styled elements and presentation components
import Header from "../Header";
import SideBarNavItem from "./SideBarNavItem";

// Utils
import { AUTH_USER_TOKEN } from "../../Utils/LocalStorage";
import { convertToSelector } from "../../Utils/Helpers";

import {
  PageWrap,
  Spacer,
  LogoCont,
  Logo,
  SideBarWrapper,
  LogoutButton
} from "./StyledElements";

// CSS styling
import "./index.css";

type PropsType = RouteComponentProps<any> & {
  render: React.ReactNode;
  title: string;
  navItems: Array<{
    to: string;
    title: string;
    icon: React.ReactElement<any>;
  }>;
  history: any;
};

class Sidebar extends React.Component<PropsType> {
  // Log out/Sign out
  handleLogout = (): void => {
    const { history } = this.props;
    window.localStorage.removeItem(AUTH_USER_TOKEN);
    history.push("/sign-in");
  };

  render() {
    const { render, navItems, title } = this.props;

    return (
      <AppContextConsumer>
        {context => {
          const sideBarOpen = !context ? false : context.state.drawerOpen;
          const toggleDrawer = !context ? null : context.toggleDrawer;

          return (
            <PageWrap>
              <Spacer open={sideBarOpen} />
              <LogoCont open={sideBarOpen}>
                <HamburgerIcon onClick={toggleDrawer} open={sideBarOpen} />
                <Logo open={sideBarOpen}>m.</Logo>
              </LogoCont>
              <SideBarWrapper className="custom-sidebar" open={sideBarOpen}>
                <Nav>
                  {navItems.map((item, i) => {
                    return (
                      <SideBarNavItem
                        key={item.to}
                        to={item.to}
                        navId={convertToSelector(item.title)}
                        icon={item.icon}
                        title={item.title}
                      />
                    );
                  })}
                </Nav>
                <LogoutButton
                  open={sideBarOpen}
                  onClick={() => this.handleLogout()}
                  className={`${
                    sideBarOpen ? "nav-link" : "nav-link-text-hidden"
                  }`}
                >
                  <FaSignOutAlt
                    size="1.3em"
                    color="#fff"
                    className={sideBarOpen ? "" : "nav-svg"}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <span style={{ color: "#fff", fontSize: "1.0.5em" }}>
                    Sign out
                  </span>
                </LogoutButton>
              </SideBarWrapper>
              <React.Fragment>
                <Header pageTitle={title} />
                <PageWrap style={{ paddingTop: 70, flex: 1 }}>
                  {render}
                </PageWrap>
              </React.Fragment>
            </PageWrap>
          );
        }}
      </AppContextConsumer>
    );
  }
}

export default withRouter(Sidebar);



// WEBPACK FOOTER //
// ./src/Components/Sidebar/index.tsx